export const SIGNEDURL_BACKEND_ENDPOINT = 'https://d1cdbbnuzj7idz.cloudfront.net/prod/signurl'
export const CFSTATIC_BACKEND_ENDPOINT = 'https://d28nynx0ys6755.cloudfront.net/api'
export const DIRECTSTATIC_BACKEND_ENDPOINT = 'https://caching-backend.pgjaiganesh.space/api'
export const WATERMARK_IMAGE_ENDPOINT = "https://d296dlyyh7mn7k.cloudfront.net/"
export const CACHING_BACKEND_ENDPOINT = "https://d1qpr2b61meppc.cloudfront.net/"
export const NO_ATTEMPTS = [
    {
      "label": 25,
      "value": 25
    },
    {
        "label": 50,
        "value": 50
      },
      {
        "label": 75,
        "value": 75
      },

]
export const CACHE_NO_ATTEMPTS = 15
export const NO_ATTEMPTS_LARGEFILES = 10
export const PERFORMANCE_ENTRIES = 600
export const PRICING_BACKEND_ENDPOINT = 'https://d1d6kxn3oboaih.cloudfront.net'
export const CMCD_STREAM_ENDPOINT = 'https://d1dsrp45dqcxe6.cloudfront.net/video/hls/buck_bunny/Big_BuckBunny_5mins.m3u8'
// export const INSPECT_REQUEST_ENDPOINT = "https://integrationpointsstack-us-east-1-cf.demos.edge.aws.dev/"
export const INSPECT_REQUEST_ENDPOINT = "https://d166yjzzba2lk5.cloudfront.net/"
export const FEEDBACK_ENDPOINT = 'https://d1d6kxn3oboaih.cloudfront.net'
export const WAF_DASHBOARD_ENDPOINT = "https://search-osdfw-opensearch-domain-evjwzsrpaygh7jpb3tb53rvzgi.us-east-1.es.amazonaws.com/_dashboards/app/dashboards#/view/main-dashboard?_g=(filters%3A!()%2CrefreshInterval%3A(pause%3A!t%2Cvalue%3A10000)%2Ctime%3A(from%3Anow-1d%2Cto%3Anow))"
// export const CDN_FINDER_ENDPOINT = "https://d2u8wb9u3zuxnh.cloudfront.net/"
export const CDN_FINDER_ENDPOINT = "https://d1bg8nzecy8ghc.cloudfront.net/"
export const WAFCOMMON_ENDPOINT = "https://d3az5q5lpqfw4v.cloudfront.net"
export const ORIGINFAILOVER_ENDPOINT = "https://d3ftutdm0kks82.cloudfront.net"
export const WAFATP_ENDPOINT = "https://d23hu88hzopab6.cloudfront.net"
export const MULTI_CDN_ENDPOINT = "https://g-286a68fcac.grafana-workspace.us-east-1.amazonaws.com/d/1CuRJMKVz/cdn-comparison-performance-metrics?orgId=1"
export const CF_RUM_ENDPOINT = "https://g-286a68fcac.grafana-workspace.us-east-1.amazonaws.com/d/FL-7Nz5Vk2/observability-website-performance?orgId=1"
export const SIMPLE_CHANNEL_ENDPOINT = "https://dl0aiy1r4giyd.cloudfront.net/"
export const DEMOPORTAL_USAGE_ENDPOINT = "https://g-e700501c45.grafana-workspace.us-east-1.amazonaws.com/d/Lkpvpv24z/demo-portal-usage-stats?orgId=1"
export const CONTENT_DISCOVERY_ENDPOINT = "https://l231lapeg5.execute-api.us-east-1.amazonaws.com/"
export const EDGE_CONFIGURATOR_ENDPOINT = "https://d3v4yk0ezmc1sa.cloudfront.net/"
// export const EDGE_CONFIGURATOR_ENDPOINT = "http://127.0.0.1:8000"
// export const TREND_ANALYSIS_ENDPOINT = "http://127.0.0.1:8000"
export const TREND_ANALYSIS_ENDPOINT = "https://dr1axgksl7fhs.cloudfront.net/"
export const MEDIA_CONTENT_DISCOVERY_ENDPOINT = "https://gd580g5zp8.execute-api.us-east-1.amazonaws.com/"
// export const INSIGHTS_ANALYSIS_ENDPOINT = "http://localhost:8000/"
export const INSIGHTS_ANALYSIS_ENDPOINT = "https://d2zf2vdlkr9s9v.cloudfront.net"
// RID Analyzer WebSocket endpoint
export const RID_ANALYZER_ENDPOINT = process.env.REACT_APP_RID_ANALYZER_ENDPOINT || "wss://d2cit47l1rd065.cloudfront.net"
// RID Analyzer HTTP endpoint (fallback)
export const RID_ANALYZER_HTTP_ENDPOINT = "https://d2cit47l1rd065.cloudfront.net"

// Edge Functions demos
// Steering Generator — AgentCore agent fronted by CloudFront

export const EDGE_FUNCTIONS_CF_ENDPOINT = "https://d3iq6b81xo3fcm.cloudfront.net"
// export const EDGE_FUNCTIONS_MANAGER_ENDPOINT = "https://ueyiticso5.execute-api.us-east-1.amazonaws.com/manage"
// export const EDGE_FUNCTIONS_METRICS_ENDPOINT = "https://ueyiticso5.execute-api.us-east-1.amazonaws.com/metrics"
// Blog Checker — reviews already-published blogs for accuracy. Updated by
// backend/blog-checker/deploy.sh on each deployment.
export const EDGE_FUNCTIONS_NORMALIZE_CF_ENDPOINT = "https://d39c141ec40obs.cloudfront.net"
export const EDGE_FUNCTIONS_JWT_CF_ENDPOINT = "https://dbg63z72urxyg.cloudfront.net"

// x402 Agent Payments — self-contained mini-stack (backend/x402-payments).
// Locally these are empty so the client uses the CRA proxy path (/api/x402 →
// localhost:8080, see setupProxy.js). deploy.sh fills them in with the real
// CloudFront URLs (agent invoker + the two seller distros + sessions API).
export const X402_INVOKER_ENDPOINT = "https://d1u2qocmq1ban9.cloudfront.net/"
export const X402_DISTRO_MONETIZED_BASE = "https://d2bmid749but3r.cloudfront.net"
export const X402_DISTRO_BLOCKED_BASE = "https://d3s1abiduwcup5.cloudfront.net"
export const X402_SESSIONS_ENDPOINT = "https://d1u2qocmq1ban9.cloudfront.net/sessions"
export const STEERING_GENERATOR_ENDPOINT = "https://d258inmrna8i5u.cloudfront.net"
// Image Search — semantic vector search over images indexed by Blog Checker
// (backend/image-search). Empty locally so the client falls back to the CRA
// proxy (/api/imagesearch → localhost:8084, see setupProxy.js); deploy.sh
// fills this in with the real CloudFront URL.
export const IMAGE_SEARCH_ENDPOINT = "https://d1n9q2v8nwjq9i.cloudfront.net"
export const BLOG_CHECKER_ENDPOINT = "https://drce8hfcysuxt.cloudfront.net"
// Networking Architecture Builder - static tool served by its own stack
// (backend/networking-architecture-builder: S3 + OAC + CloudFront). Empty until
// deploy.sh runs; deploy.sh fills it with the distribution's base URL.
export const NETWORKING_ARCHITECTURE_BUILDER_ENDPOINT = "https://df6m40n24xq39.cloudfront.net"
// Edge Experience Center (Edge Hub) - static customer view served by its own
// stack (backend/edge-experience-center: S3 + OAC + CloudFront, /customer/).
// Empty until deploy.sh runs; deploy.sh fills it with the distribution's base URL.
export const EDGE_EXPERIENCE_CENTER_ENDPOINT = "https://d203zm5rl80udq.cloudfront.net"
